import { TrustAPI } from '@/shared/modules/trust-api';
import { EeSignUpForm } from '@/shared/modules/typescript-trustapi-client/models';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import { orderBy } from "lodash";
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import ApproveRejectToBeEEModal from './approve-reject-signup-modal/index.vue';
@Options({
  components: {
    ApproveRejectToBeEEModal,
    LoadingIndicator,
    ErrorIndicator
  }
})
export default class TrustDataExternalExaminerSignUpApproval extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private tableHeadings = [
    { text: 'LawID', value: 'lawid', sortable: false },
    { text: 'Name', value: 'name', sortable: false },
    { text: 'Firm name', value: 'firmname', sortable: false },
    { text: 'Suburb', value: 'suburb', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private selectedEESignUpForm: EeSignUpForm = {};

  private actionType = -1;

  private searchKeyword = '';
  private showSubmmitted = true;
  private showRejected = false;
  private showApproveRejectModal = false;
  // private showAddEditModal = false;
  // private showAuditTrailModal = false;
  private loadingContent = false;
  private errorLoadingContent = false;

  private eeSignUpForms: EeSignUpForm[] = [];


  created(): void {
    this.loadEESignUpFormsList();
  }

  mounted() {
    this.eventCtrl.on('reload-ee-signup-forms', this.loadEESignUpFormsList);
  }

  beforeUnmount() {
    this.eventCtrl.off('reload-ee-signup-forms', this.loadEESignUpFormsList);
  }
  

  private async loadEESignUpFormsList(): Promise<void> {
    try {
      this.loadingContent = true;
      this.errorLoadingContent = false;
  
      const resp: any =
        await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminGetEeSignUpFormGet();
        this.eeSignUpForms = resp.data.data as EeSignUpForm[];
        this.eeSignUpForms = orderBy(
          this.eeSignUpForms,
          [data => data.lawId.toLowerCase()],
          ['asc']
        );
    } catch (err) {
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private approveToBeEE(eeSignUpForm: EeSignUpForm): void {
    this.actionType = 1;
    this.selectedEESignUpForm = eeSignUpForm;
    this.showApproveRejectModal = true;
  }

  private rejectToBeEE(eeSignUpForm: EeSignUpForm): void {
    this.actionType = 2;
    this.selectedEESignUpForm = eeSignUpForm;
    this.showApproveRejectModal = true;
  }
  

  private viewSignUpForm(eeSignUpForm: EeSignUpForm): void {
    this.actionType = 3;
    this.selectedEESignUpForm = eeSignUpForm;
    this.showApproveRejectModal = true;
  }

  private onApproveRejectModalClosed(): void {
    this.showApproveRejectModal = false;
    this.actionType = -1;
  }

  get filteredEESignUpForms(): EeSignUpForm[] {
    let eeSignUpFormsTemp: EeSignUpForm[] = [];
    let eeSignUpFormsSubmittedTemp: EeSignUpForm[] = [];
    let eeSignUpFormsRjectedTemp: EeSignUpForm[] = [];
    
    eeSignUpFormsSubmittedTemp = this.eeSignUpForms.filter(
      x => x.eeSignUpFormStatus.name == 'Submitted'
    );

    eeSignUpFormsRjectedTemp = this.eeSignUpForms.filter(
      x => x.eeSignUpFormStatus.name == 'Rejected'
    );

    if (this.showSubmmitted) {
      eeSignUpFormsTemp.push(...eeSignUpFormsSubmittedTemp);
    }

    if (this.showRejected) {
      eeSignUpFormsTemp.push(...eeSignUpFormsRjectedTemp);
    }

    if (!this.showSubmmitted && !this.showRejected) {
      eeSignUpFormsTemp = this.eeSignUpForms;
    }

    if (this.searchKeyword.trim()) {
      eeSignUpFormsTemp = this.eeSignUpForms.filter(
        x => x.firstName.toLocaleLowerCase().includes(this.searchKeyword.toLocaleLowerCase()) ||
          x.surname.toLocaleLowerCase().includes(this.searchKeyword.toLocaleLowerCase()) ||
          x.lawId.toLocaleLowerCase().includes(this.searchKeyword.toLocaleLowerCase())
      );
    }

    return eeSignUpFormsTemp;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }
}
